import _ from 'lodash'
import * as mutationTypes from './mutation-types'
import { mixedSort } from '@app/utils/sort'
import { InsightsStaticColumns, RIGHT_ALIGN_FILTER_TYPES } from '../constants'

const ASC = 'asc'
const DESC = 'desc'

const getters = {
  companyColumns(_state, getters) {
    return [...getters.defaultColumns, ...getters.additionalColumns]
  },
  defaultColumns(_state, _getters, rootState) {
    const columns = [
      {
        name: InsightsStaticColumns.NAME,
        title: I18n.t('companies_overview.columns.client_file_name'),
        classes: 'sf-fwb',
      },
    ]
    if (rootState.periodSelection) {
      columns.push({
        name: InsightsStaticColumns.SELECTED_PERIOD,
        title: I18n.t('companies_overview.selected_period_title'),
      })
    }
    return columns
  },
  additionalColumns(_state, getters) {
    const { getActiveFilters, getFilterHeaderTitle } = getters

    return getActiveFilters.map((filter) => {
      let alignment = ''

      if (RIGHT_ALIGN_FILTER_TYPES.includes(filter.type)) {
        alignment = 'sf-align-r tw-ml-auto'
      }

      return {
        name: filter.uuid,
        title: getFilterHeaderTitle(filter),
        alignment,
        filter,
      }
    })
  },
  getColumnSortMethod(state) {
    const accessorMethod = (o) => o.filter_values[state.sortColumn]?.sort_value
    const priorityMethod = (o) =>
      !!o.filter_values[state.sortColumn]?.filter_error

    if (state.sortType === ASC) {
      return (collection) => {
        return mixedSort(
          Object.values(collection),
          accessorMethod,
          priorityMethod
        )
      }
    } else {
      return (collection) => {
        return _.reverse(
          mixedSort(Object.values(collection), accessorMethod, priorityMethod)
        )
      }
    }
  },
  isAscending: (state) => state.sortType === ASC,
}

const mutations = {
  [mutationTypes.TOGGLE_SORT_TYPE](state) {
    state.sortType = state.sortType === ASC ? DESC : ASC
  },
  [mutationTypes.SET_SORT_COLUMN](state, { sortColumn, sortType }) {
    state.sortColumn = sortColumn
    state.sortType = sortType || ASC
  },
}

const actions = {
  changeSort({ commit, state }, sortColumn) {
    if (state.sortColumn === sortColumn) {
      commit(mutationTypes.TOGGLE_SORT_TYPE)
    } else {
      commit(mutationTypes.SET_SORT_COLUMN, { sortColumn })
    }
  },
  setSortAndType({ commit }, { sortColumn, sortType }) {
    commit(mutationTypes.SET_SORT_COLUMN, { sortColumn, sortType })
  },
}

export default {
  state() {
    return {
      sortColumn: 'name',
      sortType: ASC,
    }
  },
  getters,
  mutations,
  actions,
}
